import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getActionMessageInfo } from 'automation-ui-action-features/actions/rotate-object/utils/action-message';
import { checkIsUnassigned, getRoutingRules } from 'automation-ui-action-features/actions/rotate-object/utils/routing-rules';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { checkCanHaveFallback } from 'routing-ui/routing-rules/operators/routingRulesGetters';
import { jsx as _jsx } from "react/jsx-runtime";
export const UnifiedRoutingActionDetail = ({
  actionMetadata,
  objectTypeId
}) => {
  const elements = {
    ObjectTypeName
  };
  const routingRuleDefinition = getRoutingRules(actionMetadata);
  if (checkIsUnassigned(routingRuleDefinition)) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: elements,
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-detail.no-one_jsx",
      options: {
        objectTypeId
      }
    });
  }
  if (checkCanHaveFallback(routingRuleDefinition)) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: elements,
      message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-detail.contact-owner_jsx",
      options: {
        objectTypeId
      }
    });
  }
  const {
    distribution,
    teamCount,
    type,
    userCount
  } = getActionMessageInfo(routingRuleDefinition);
  switch (type) {
    case 'multiple-both':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: elements,
        message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-detail.users-and-teams.multiple-both_jsx",
        options: {
          distribution,
          objectTypeId,
          teamCount,
          userCount
        }
      });
    case 'single-both':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: elements,
        message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-detail.users-and-teams.single-both_jsx",
        options: {
          distribution,
          objectTypeId
        }
      });
    case 'single-team':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: elements,
        message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-detail.users-and-teams.single-team_jsx",
        options: {
          distribution,
          objectTypeId,
          userCount
        }
      });
    case 'single-user':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: elements,
        message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-detail.users-and-teams.single-user_jsx",
        options: {
          distribution,
          objectTypeId,
          teamCount
        }
      });
    case 'teams-only':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: elements,
        message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-detail.teams-only_jsx",
        options: {
          count: teamCount,
          distribution,
          objectTypeId
        }
      });
    case 'users-only':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: elements,
        message: "automation-ui-action-features.action-features.rotate-object.unified-routing.action-detail.users-only_jsx",
        options: {
          count: userCount,
          distribution,
          objectTypeId
        }
      });
    default:
      return null;
  }
};
UnifiedRoutingActionDetail.dsiplayName = 'UnifiedRoutingActionDetail';